import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { enrichmentFilters, makpezaFilter } from "../../../shared/utils/entitiesFiltersUtils";
import Page from "../../../shared/components/ui/page/Page";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import pathRouts from "../../../shared/enums/pathRoute";
import MySelfLearningWidget from "./mySelfLearningWidget/MySelfLearningWidget";
import BannerItem from "../../../shared/components/features/BannerItem/BannerItem";
// import BagroupAndMakpezeBanners from "../../../shared/components/features/bagroupAndMakpezeBanners/BagroupAndMakpezeBanners";
import CourseGallery from "../../../shared/components/features/courseGallery/CourseGallery";
import classes from "./PlusLearningPage.module.css";


const PlusLearningPage = () => {

    const { texts, lang } = useSelector(state => state.translate);
    const navigate = useNavigate();
    const { general } = useSelector(state => state.uiData);
    const makpezaFilters = useMemo(() => makpezaFilter(lang), [lang]);
    const enrichmentFiltersList = useMemo(() => enrichmentFilters(lang), [lang]);
    const makpezaCourses = useSelector(state => selectEntitiesByFilters(state, makpezaFilters));
    const enrichmentCourses = useSelector(state => selectEntitiesByFilters(state, enrichmentFiltersList));

    return (
        <Page title={texts.plusLearning} icon={iconsList.plusLearning} onBack={() => navigate(`/${pathRouts.HOME}`)}>
            <div className={classes.PlusLearningPage}>
                <p className={classes.PlusLearningTitel}>{texts.plusLearning}</p>
                <div className={classes.TopPart}>
                    <MySelfLearningWidget />
                    <div className={classes.Banners}>
                        {general?.PlusLearningPageBanners?.map((banner, index) =>
                            <BannerItem banner={banner} className={classes.Banner} dropClass={classes.Banner} key={index} />
                        )}
                    </div>
                    {/* <BagroupAndMakpezeBanners /> */}
                </div>
                <div className={classes.BottomPart}>
                    <div className={classes.Gallery}>
                        <CourseGallery
                            courses={makpezaCourses}
                            title={texts.makpeza}
                        />
                    </div>
                    <div className={classes.Gallery}>
                        <CourseGallery
                            courses={enrichmentCourses}
                            title={texts.enrichmentForYou}
                        />
                    </div>
                </div>
            </div>
        </Page>
    );
};

export default PlusLearningPage;